module.exports = __webpack_public_path__ + "static/img/new-004.d405c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-004.png
// module id = PCLB
// module chunks = 1